import { AppThunk } from '../store';

export const setJob =
  (value: any): AppThunk =>
  dispatch => {
    dispatch({
      type: 'UPDATE_JOB',
      payload: value,
    });
  };

export const resetJob = (): AppThunk => dispatch => {
  dispatch({
    type: 'RESET',
  });
};
